import { render, staticRenderFns } from "./SaleProductCard.vue?vue&type=template&id=c73347d2&scoped=true&"
import script from "./SaleProductCard.vue?vue&type=script&lang=js&"
export * from "./SaleProductCard.vue?vue&type=script&lang=js&"
import style0 from "./SaleProductCard.vue?vue&type=style&index=0&id=c73347d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73347d2",
  null
  
)

export default component.exports